// OC(운영 크레딧) 표시용 공통 상수와 라벨. 세 관리자 surface가 함께 쓴다.

/** 매장 OC 잔액이 이 값 이하이면 경고한다(바이인 1건당 1 OC 차감). */
export const LOW_STORE_OC_THRESHOLD = 10;

export function isLowStoreOc(balance: number | null | undefined): boolean {
  return typeof balance === 'number' && balance <= LOW_STORE_OC_THRESHOLD;
}

/** oc_transactions.transaction_type 실제 값(docs/schema.sql CHECK 제약) -> 한글 라벨 */
export const OC_TRANSACTION_TYPE_LABEL: Record<string, string> = {
  charge: '충전',
  deduct: '차감',
  buy_in_fee: '바이인 수수료',
  re_buy_in_fee: '리바이인 수수료',
  item_commission: '아이템 수수료',
  adjustment_credit: '조정(증가)',
  adjustment_debit: '조정(차감)',
};

export const OC_TRANSACTION_TYPE_OPTIONS = Object.entries(OC_TRANSACTION_TYPE_LABEL).map(([value, label]) => ({
  value,
  label,
}));

export function ocTransactionTypeLabel(type: string): string {
  return OC_TRANSACTION_TYPE_LABEL[type] ?? type;
}

export type OcRequestStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';
export type OcRequestType = 'issue' | 'adjust';

export const OC_REQUEST_STATUS_LABEL: Record<OcRequestStatus, string> = {
  pending: '대기',
  approved: '승인',
  rejected: '반려',
  cancelled: '취소',
};

export const OC_REQUEST_STATUS_TONE: Record<OcRequestStatus, 'warning' | 'success' | 'danger' | 'neutral'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'danger',
  cancelled: 'neutral',
};

export const OC_REQUEST_TYPE_LABEL: Record<OcRequestType, string> = {
  issue: '충전',
  adjust: '조정',
};

/** 시스템 관리자 승인 화면용: 요청이 반영될 대상(매장 또는 본사)을 사람이 읽는 문구로 만든다. */
export function describeOcRequestTarget(row: {
  franchise_name: string;
  store_id: string | null;
  store_name: string | null;
}): { kind: '매장' | '본사'; label: string } {
  if (row.store_id) {
    return { kind: '매장', label: `${row.franchise_name} / ${row.store_name ?? row.store_id.slice(0, 8)}` };
  }
  return { kind: '본사', label: `${row.franchise_name} 본사` };
}
